import React from "react";
import { Box, Button, Typography, Dialog, DialogContent } from "@mui/material";

import LogoutIcon from "../assets/images/Logout.png";

export default function LogoutPopup({
  logoutDialogOpen,
  handleLogoutClose,
  handleConfirmLogout,
}) {
  return (
    <Box>
      <Dialog
        open={logoutDialogOpen}
        onClose={handleLogoutClose}
        PaperProps={{
          sx: {
            borderRadius: "34px", // Apply 100px border radius to the dialog box
            overflow: "hidden", // Ensure content stays within rounded corners
          },
        }}
      >
        <DialogContent
          sx={{
            textAlign: "center",
            padding: "24px 16px",
            display: "flex", // Use flexbox
            flexDirection: "column", // Stack items vertically
            alignItems: "center", // Center items horizontally
          }}
        >
          {/* Icon Box */}
          <Box
            sx={{
              width: "70px",
              height: "70px",
              borderRadius: "50%",
              backgroundColor: "#F1F7FA",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "16px", // Add spacing below the icon
            }}
          >
            <img src={LogoutIcon} width={30} height={30} />
          </Box>

          {/* Title */}
          <Typography
            color="#2A4876"
            variant="h6"
            fontWeight="bold"
            gutterBottom
          >
            We hope to see you again soon!
          </Typography>

          {/* Message */}
          <Typography variant="body2" color="textSecondary">
            Are you sure you want to log out of this profile?
          </Typography>

          {/* Buttons */}
          <Box mt={3} display="flex" justifyContent="center" gap={2}>
            <Button
              onClick={handleConfirmLogout} // Confirms logout
              sx={{
                textTransform: "none",
                borderRadius: "34px",
                backgroundColor: "#AAB6C8",
                color: "#2A4876",
                fontWeight: "bold",
                padding: "12px 44px",
                "&:hover": { backgroundColor: "#C4CED8" },
              }}
            >
              Yes
            </Button>
            <Button
              onClick={handleLogoutClose} // Closes the popup
              sx={{
                textTransform: "none",
                borderRadius: "34px",
                backgroundColor: "#2A4876",
                color: "#FFFFFF",
                fontWeight: "bold",
                padding: "12px 44px",
                "&:hover": { backgroundColor: "#002A5C" },
              }}
            >
              No
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
